export default class PieceShipmentModel {
  constructor({
    id, weight, type, width, height, depth,
  }) {
    this.id = id;
    this.weight = weight;
    this.type = type;
    this.width = width;
    this.height = height;
    this.depth = depth;
  }

  /**
   * @param model
   * @return {PieceShipmentModel}
   */
  static createFromPieceModel(model) {
    const {
      dimensions,
      id,
      weight,
      type,
    } = model;

    return new PieceShipmentModel({
      id,
      weight,
      type: type.type,
      width: dimensions ? dimensions.width : null,
      height: dimensions ? dimensions.height : null,
      depth: dimensions ? dimensions.depth : null,
    });
  }

  /**
   * @param models Array
   * @return [PieceShipmentModel]
   */
  static createFromPieceModels(models) {
    return models.map(m => PieceShipmentModel.createFromPieceModel(m));
  }
}
